import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { useEffect } from 'react';
import ReactModal from 'react-modal';
import { DRAWER_HEIGHT_CSS_VAR } from "../constants/cssVariables";
import { CLOSE_TIMEOUT_MS } from "../constants/timeout";
import * as styles from "../styles/Drawer.styles";
import { ModalWithScopedStyles } from "../../../..";
export var OVERLAY_DRAWER_TESTID = 'overlay-drawer-testid';
var setDrawerHeight = function setDrawerHeight() {
  return document.documentElement.style.setProperty(DRAWER_HEIGHT_CSS_VAR, "".concat(window.innerHeight, "px"));
};
var DRAWER_CONTENT_CLASS_NAMES = {
  base: 'drawer-content',
  afterOpen: 'drawer-content--afterOpen',
  beforeClose: 'drawer-content--beforeClose'
};
var DRAWER_OVERLAY_CLASS_NAMES = {
  base: 'drawer-overlay',
  afterOpen: 'drawer-overlay--afterOpen',
  beforeClose: 'drawer-overlay--beforeClose'
};
var DrawerGlobalStyles = styles.DrawerGlobalStyles({
  contentClassNames: DRAWER_CONTENT_CLASS_NAMES,
  overlayClassNames: DRAWER_OVERLAY_CLASS_NAMES,
  closeTimeoutMS: CLOSE_TIMEOUT_MS
});
export var Drawer = function Drawer(_ref) {
  var children = _ref.children,
    contentContainerStyles = _ref.contentContainerStyles,
    contentLabel = _ref.contentLabel,
    describedBy = _ref.describedBy,
    isOpen = _ref.isOpen,
    onAfterClose = _ref.onAfterClose,
    onOverlayClick = _ref.onOverlayClick,
    onRequestClose = _ref.onRequestClose,
    _ref$panelSize = _ref.panelSize,
    panelSize = _ref$panelSize === void 0 ? 'full' : _ref$panelSize,
    _ref$transitionFrom = _ref.transitionFrom,
    transitionFrom = _ref$transitionFrom === void 0 ? 'right' : _ref$transitionFrom,
    useScopedStyles = _ref.useScopedStyles;
  useEffect(function () {
    var handler = function handler() {
      // Note: value not always correctly set/updated on Android within Testcafe tests on Browserstack...
      setDrawerHeight();
    };
    handler();
    window.addEventListener('resize', handler);
    return function () {
      return window.removeEventListener('resize', handler);
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DrawerGlobalStyles, null), /*#__PURE__*/React.createElement(ModalWithScopedStyles, {
    aria: {
      modal: true,
      describedby: describedBy || ''
    },
    className: DRAWER_CONTENT_CLASS_NAMES,
    closeTimeoutMS: CLOSE_TIMEOUT_MS,
    contentLabel: contentLabel,
    data: {
      'transition-from': transitionFrom,
      'panel-size': panelSize
    },
    isOpen: isOpen,
    onAfterClose: onAfterClose,
    onAfterOpen: function onAfterOpen() {
      /* Note: The innerHeight value returned within the hook above is not always correct when running the Testcafe
      tests on Android within Browserstack, therefore explicitly redefine it here */
      setDrawerHeight();
    },
    onRequestClose: onRequestClose,
    overlayClassName: DRAWER_OVERLAY_CLASS_NAMES,
    useScopedStyles: useScopedStyles
  }, onOverlayClick && /*#__PURE__*/React.createElement(_StyledDiv, {
    "aria-hidden": true,
    "data-testid": OVERLAY_DRAWER_TESTID,
    onClick: onOverlayClick,
    $_css: styles.modalOverlay
  }), /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [styles.drawerContent, contentContainerStyles]
  }, children)));
};
export var setAppElement = ReactModal.setAppElement;
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "Drawer___StyledDiv2",
  componentId: "sc-1gd5fss-0"
})(["", ""], function (p) {
  return p.$_css2;
});